import { render, staticRenderFns } from "./zhifu.vue?vue&type=template&id=56e2afc8&scoped=true&"
import script from "./zhifu.vue?vue&type=script&lang=js&"
export * from "./zhifu.vue?vue&type=script&lang=js&"
import style0 from "./zhifu.vue?vue&type=style&index=0&id=56e2afc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e2afc8",
  null
  
)

export default component.exports